export const calendar = {
  title: 'Il Mio Calendario',
  subtitle: 'Gestisci la tua disponibilità e sincronizza i tuoi calendari',
  calendar: {
    today: 'Oggi',
    month: 'Mese',
    week: 'Settimana',
    day: 'Giorno',
    selectDates: 'Seleziona date',
    blockDates: 'Blocca date',
    unblockDates: 'Sblocca queste date',
    addNote: 'Aggiungi nota',
    selectEvent: 'Seleziona un evento',
    nMonths: 'mesi',
    oneMonth: '1 mese',
    months: { january: 'Gennaio', february: 'Febbraio', march: 'Marzo', april: 'Aprile', may: 'Maggio', june: 'Giugno', july: 'Luglio', august: 'Agosto', september: 'Settembre', october: 'Ottobre', november: 'Novembre', december: 'Dicembre' },
    days: { monday: 'Lun', tuesday: 'Mar', wednesday: 'Mer', thursday: 'Gio', friday: 'Ven', saturday: 'Sab', sunday: 'Dom' }
  },
  sync: { title: 'Sincronizzazione iCal', description: 'Connetti il tuo calendario Airbnb o PMS per sincronizzare automaticamente la tua disponibilità', addConnection: 'Aggiungi connessione', noConnections: 'Nessuna connessione', icalUrl: 'URL iCal', icalUrlPlaceholder: 'https://www.airbnb.com/calendar/ical/...', platform: 'Piattaforma', platformPlaceholder: 'Es: Airbnb, Booking.com, PMS...', syncNow: 'Sincronizza ora', lastSync: 'Ultima sincronizzazione', eventsImported: 'eventi importati', status: { synced: 'Sincronizzato', pending: 'In sospeso', error: 'Errore', syncing: 'Sincronizzazione in corso...' }, remove: 'Rimuovi', edit: 'Modifica' },
  exchanges: { title: 'Scambi Imminenti', noExchanges: 'Nessuno scambio pianificato', viewProfile: 'Visualizza profilo', sendMessage: 'Invia messaggio', confirm: 'Conferma', decline: 'Rifiuta', cancel: 'Annulla', guests: 'viaggiatori', status: { confirmed: 'Confermato', pending: 'In sospeso', proposal: 'Proposta', blocked: 'Bloccato' } },
  legend: { title: 'Legenda', available: 'Disponibile', confirmed: 'Scambio confermato', pending: 'Richiesta in sospeso', proposal: 'Proposta', blocked: 'Date bloccate' },
  blockModal: { title: 'Blocca date', reason: 'Motivo (facoltativo)', reasonPlaceholder: 'Es: Ristrutturazioni, vacanza personale...', from: 'Da', to: 'A', block: 'Blocca', cancel: 'Annulla' },
  notifications: { datesBlocked: 'Date bloccate con successo', datesUnblocked: 'Date sbloccate con successo', syncSuccess: 'Sincronizzazione riuscita', syncError: 'Errore di sincronizzazione', connectionAdded: 'Connessione aggiunta con successo', connectionRemoved: 'Connessione rimossa', exchangeConfirmed: 'Scambio confermato', exchangeDeclined: 'Scambio rifiutato' },
  details: 'Dettagli',
  upcomingExchanges: 'Scambi Imminenti',
  noExchangesPlanned: 'Nessuno scambio pianificato',
  daysSelected: 'giorni selezionati',
  daySelected: 'giorno selezionato',
  from: 'Da',
  to: 'A',
  reasonOptional: 'Motivo (facoltativo)',
  reasonPlaceholder: 'Es: Ristrutturazioni, vacanza personale...',
  block: 'Blocca',
  cancel: 'Annulla',
  namePlaceholder: 'Nome (es: Airbnb)',
  filters: 'Filtri',
  actions: 'Azioni',
  connections: 'Connessioni'
};

export default calendar;
